import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Row,
    Spinner,
    Table,
} from "reactstrap";
import { promotionActions } from "../../sagas/promotionSlice";
import PromotionFormModal from "./PromotionFormModal";

const PromotionListPage = () => {
    const dispatch = useDispatch();
    const { list, loading, printing } = useSelector((state) => state.promotions);

    const [openModal, setOpenModal] = useState(false);

    const toggleModal = () => setOpenModal(!openModal);

    useEffect(() => {
        dispatch(promotionActions.list());
    }, [dispatch]);

    const refreshList = () => {
        dispatch(promotionActions.list());
    };

    const handlePrint = (id) => {
        dispatch(
            promotionActions.print({
                id,
                onSuccess: () => {},
                onError: () => {},
            })
        );
    };

    const getStatusBadgeClass = (status) => {
        switch (status) {
            case "ACTIVE":
                return "badge bg-success";
            case "DRAFT":
                return "badge bg-warning text-dark";
            case "EXPIRED":
                return "badge bg-secondary";
            case "CANCELLED":
                return "badge bg-danger";
            default:
                return "badge bg-light text-dark";
        }
    };

    return (
        <div className="page-content">
            <Row>
                <Col lg={12}>
                    <Card>
                        <CardHeader className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">Promotions / Tickets promo</h4>
                            <Button color="primary" onClick={toggleModal}>
                                + Nouvelle promotion
                            </Button>
                        </CardHeader>

                        <CardBody>
                            {loading ? (
                                <div className="text-center py-4">
                                    <Spinner />
                                </div>
                            ) : (
                                <Table bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Code</th>
                                            <th>Libellé</th>
                                            <th>Status</th>
                                            <th>Date début</th>
                                            <th>Date fin</th>
                                            <th>Nb tickets</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!list || list.length === 0 ? (
                                            <tr>
                                                <td colSpan="8" className="text-center text-muted">
                                                    Aucune promotion trouvée
                                                </td>
                                            </tr>
                                        ) : (
                                            list.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>{item.code}</td>
                                                    <td>{item.libelle}</td>
                                                    <td>
                                                        <span className={getStatusBadgeClass(item.status)}>
                                                            {item.status}
                                                        </span>
                                                    </td>
                                                    <td>{item.dateDebut || "-"}</td>
                                                    <td>{item.dateFin || "-"}</td>
                                                    <td>{item.tickets?.length || 0}</td>
                                                    <td>
                                                        <div className="d-flex gap-2">
                                                            <Button
                                                                color="info"
                                                                size="sm"
                                                                onClick={() => handlePrint(item.id)}
                                                                disabled={printing}
                                                            >
                                                                Imprimer PDF
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <PromotionFormModal
                isOpen={openModal}
                toggle={toggleModal}
                onCreated={refreshList}
            />
        </div>
    );
};

export default PromotionListPage;